module.exports = __webpack_public_path__ + "static/img/brees-2008-slide-5.dbc49a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2008-slide-5.jpg
// module id = Zqfo
// module chunks = 1